import { SVGProps } from "react";

export const Pin2Icon = ({
  color = "currentColor",
  size = 16,
  strokeWidth = 1,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number }) => {
  /* Render */
  const render = () => (
    <svg width={size} height={size} {...rest} fill="none" viewBox="0 0 24 24">
      <path
        fill="none"
        d="M19.5 11.5 14 10l-1.5 -5.5 4 -4 5.6 1.4 1.4 5.6 -4 4Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill={color}
        opacity={0.2}
        d="m14.1 10 5.4 1.5 4 -3.99999 -1.4 -5.4L14.1 10Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M19.5 11.5 14 10l-1.5 -5.5 4 -4 5.6 1.4 1.4 5.6 -4 4Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="m15.5 5 2 -2 1.4 0.3"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M0.5 23.5 14 10"
        strokeWidth={strokeWidth}
      ></path>
    </svg>
  );
  return render();
};
